import { useAuthStore } from "@/lib/auth/AuthStore";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useDialogStore } from "src/store/useDialogStore";
import useCheckOrder from "../queries/useCheckOrder";
/**
 * 상품이 판매 중인지 판별한다. orderType별로 응답 필드 이름이 다르다.
 *
 * 조회 전(paymentData 없음)에는 undefined를 반환해 '판매중지(false)'와 구분한다.
 * 이 둘을 구분하지 않으면 로딩 중에 판매중지 다이얼로그가 떠버린다.
 */ export const getIsAvailable = (orderType, paymentData)=>{
    if (!paymentData) return undefined;
    switch(orderType){
        case "package":
            return "available" in paymentData && paymentData.available === true;
        case "pass":
            return "isAvailable" in paymentData && paymentData.isAvailable === true;
        // pass·package 외에는 이 검증 대상이 아니다
        default:
            return false;
    }
};
const useCheckPurchaseOrder = (param)=>{
    let { id , orderType , paymentData  } = param;
    const { isLoggedIn  } = useAuthStore();
    const { open  } = useDialogStore();
    const router = useRouter();
    const isAvailable = getIsAvailable(orderType, paymentData);
    const { data , isLoading , isError , isFetching  } = useCheckOrder({
        targetType: orderType === "pass" ? "membership" : orderType,
        targetId: id,
        enabled: isLoggedIn && (orderType === "pass" || orderType === "package") && Boolean(id) && isAvailable !== undefined
    });
    useEffect(()=>{
        // 로딩 중이거나 fetch 중이면 실행하지 않음
        if (isLoading || isFetching) return;
        // API 호출 실패 시 에러 처리
        if (isError) {
            return open({
                id: "checkPurchaseOrderError",
                type: "confirm",
                props: {
                    severity: "error",
                    title: "구매 조건 확인 실패",
                    description: "구매 가능 여부를 확인할 수 없습니다. 잠시 후 다시 시도해주세요.",
                    onConfirm: ()=>{
                        router.back();
                    }
                }
            });
        }
        // 데이터 조회가 완료되지 않았으면 실행하지 않음
        if (!data) return;
        // isAvailable이 아직 로딩 중이면 실행하지 않음
        if (isAvailable === undefined) return;
        const checkAvailable = orderType === "package" || orderType === "pass";
        // isAvailable이 false인 경우 (판매중지 상품)
        if (checkAvailable && isAvailable === false) {
            return open({
                id: "checkIsAvailable",
                type: "confirm",
                props: {
                    severity: "error",
                    title: "구매할 수 없는 상품입니다.",
                    confirmText: "돌아가기",
                    description: "판매중지 상품",
                    onConfirm: ()=>{
                        router.back();
                    }
                }
            });
        }
        // isAvailable이 true이지만 구매 불가능한 경우 (특정 회원만 구매 가능)
        if (checkAvailable && isAvailable && (data === null || data === void 0 ? void 0 : data.canPurchase) === false) {
            open({
                id: "checkPurchaseOrder",
                type: "confirm",
                props: {
                    severity: "error",
                    title: "특정 회원만 구매할 수 있어요.",
                    description: data.message || "구매 불가",
                    confirmText: "돌아가기",
                    onConfirm: ()=>{
                        router.back();
                    }
                }
            });
        }
    }, [
        data,
        isAvailable,
        open,
        router,
        orderType,
        isError,
        isLoading,
        isFetching
    ]);
};
export default useCheckPurchaseOrder;
